import { TranslationObject } from '@ngx-translate/core';
import { AspectRankingComparison } from '@lib.core/entities/indicator/indicator-ranking-comparison';

export class AspectRanking {
  title: TranslationObject;
  value: number;
  rank: number;
  compareWith: string;
  comparisons: AspectRankingComparison[];

  constructor(
    title: TranslationObject,
    value: number,
    rank: number,
    compareWith: string,
    comparisons: AspectRankingComparison[]
  ) {
    this.title = title;
    this.value = value;
    this.rank = rank;
    this.compareWith = compareWith;
    this.comparisons = comparisons;
  }
}